module.exports = __webpack_public_path__ + "img/67.4adb1b0d.jpg";